export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "isoline-job-manager-worker.worker.js");
}
